<app-form-input *ngIf="displayStar"
[parentForm]="parentForm"
[value]="objetComplementaire?.classPrincipale"
[label]="step2.getclassprincipale"
[type]="'autocompleteWithStar'"
[autoCompleteType]="'CPV'" [autoCompleteTypeIndex]="1"
[rule]="'pattern_17|required'"
[errorMessage]="{'required' : 'ctr_203_HorsDef', 'pattern' : 'ctr_204_HorsDef'}"
[name]="getUid()+'_SepAtt_classPrincipale'"
[preferenceType] = "typeCpv"
(preferenceSelected)="chargeDonneePreference($event)">
</app-form-input>

<app-form-input *ngIf="!displayStar"
[parentForm]="parentForm"
[value]="objetComplementaire?.classPrincipale"
[label]="step2.getclassprincipale"
[type]="'autocomplete'"
[autoCompleteType]="'CPV'" [autoCompleteTypeIndex]="1"
[rule]="'pattern_17|required'"
[errorMessage]="{'required' : 'ctr_203_HorsDef', 'pattern' : 'ctr_204_HorsDef'}"
[name]="getUid()+'_SepAtt_classPrincipale'">
</app-form-input>

<app-form-input
	[label]="step2.getclasssupplementaire"
	[name]="getUid() + '_SepAtt_classSupplementaire'"
	[parentForm]="parentForm"
	[disabled]="disabled"
	[type]="'chips'"
	[isCPV]="true"
	[rule]="'pattern_15'"
	[errorMessage]="{'pattern' : 'ctr_204_HorsDef'}"
	[value]="objetComplementaire?.classSupplementaire"
	[autoCompleteType]="'CLASSSUPPLEMENTAIRE'" [autoCompleteTypeIndex]="0"
	[maxLength]="3"
>